import { envFlags } from '@thoughtspot/env-flags';
import { create } from '@thoughtspot/logger';
import { collectEvent, UserAction, userActionTypeEnum, } from '@thoughtspot/metrics';
import { DEFAULT_FLAG_VALUE } from './flags.const';
const logger = create('feature-service flags');
class FeatureFlagStore {
    setContext(context) {
        this.context = context;
    }
    getContext() {
        return this.context;
    }
    setFlags(flags) {
        this.flags = flags;
    }
    getFlags() {
        return this.flags;
    }
    getFlag(flag) {
        return this.flags[flag];
    }
}
let featureFlagStore;
export function isInitialized() {
    return !!featureFlagStore;
}
export function clearFeatureFlagStore() {
    featureFlagStore = undefined;
}
export function freshInitialize(userContext, flags) {
    featureFlagStore = new FeatureFlagStore();
    featureFlagStore.setContext(userContext);
    featureFlagStore.setFlags(flags);
    collectEvent(new UserAction(userActionTypeEnum.FEATURE_SERVICE_FLAGS_INIT), { context: userContext.toString() });
}
export function initialize(userContext, flags) {
    if (!featureFlagStore) {
        freshInitialize(userContext, flags);
    }
}
export function isFeatureEnabled(key, options) {
    const urlParamValue = envFlags.getValue(key);
    if (urlParamValue !== undefined &&
        urlParamValue !== null &&
        !options?.disableUrlParam)
        return urlParamValue;
    if (options?.urlParamValue !== undefined &&
        options?.urlParamValue !== null &&
        !options?.disableUrlParam) {
        return options.urlParamValue;
    }
    if (!featureFlagStore) {
        logger.warn('Attempt to read before feature flag store was initialized');
    }
    return featureFlagStore?.getFlag(key) ?? DEFAULT_FLAG_VALUE;
}
//# sourceMappingURL=flags.js.map